import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchJvBrokers, fetchJvClients, fetchReadJvBroker, fetchReadJvClient } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";

const Brokers = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["jb-brokers", decouncedSearchValue],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.nextPageUrl = `billing/searchbroker/TaxID/${decouncedSearchValue}`;
            }

            return await fetchJvBrokers({ ...params });
        },

        select: (data) => {
            const brokerDemographics = data.pages.map((page) => page.Response.BrokerDemographic).flatMap((x) => x).filter(x => Object.keys(x)?.length)
            return {
                count: brokerDemographics?.length,
                rows: brokerDemographics

            };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            // console.log({ lastPage })
            const nextPageUrl = lastPage?.Response?.Pagination?.Next

            if (!nextPageUrl) return undefined;
            return {
                nextPageUrl: nextPageUrl.split('/rest/')[1]
            }
        },
        staleTime: 0,
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['BrokerName', 'Code', 'BrokerType', 'BrokerTypeDesc', 'TaxID', 'TaxIDType', 'PayViaEFT', 'PrintChecks', 'CheckAddress'];

    const onDetailHandler = async (body) => {
        const result = await fetchReadJvBroker({ code: body.Code })
        return result
    }

    return (
        <div className={'container '}>
            <p className='title'>Brokers</p>
            <p className="sub-title">JV Brokers</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="taxId..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"jv-broker"}
                        disableHeaderFormatting={true}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default Brokers